// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sVV7kmzFIgWPnmtymcsv7w\\=\\= {\n  margin-left: 2px;\n}\n\n.VaOP8Txgb\\+bECkL3igkXnQ\\=\\= {\n  font-weight: bold;\n}", "",{"version":3,"sources":["webpack://./src/content/styles/LessonPointsView.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".feedbackText {\n  margin-left: 2px;\n}\n\n.feedbackPoints {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feedbackText": "sVV7kmzFIgWPnmtymcsv7w==",
	"feedbackPoints": "VaOP8Txgb+bECkL3igkXnQ=="
};
export default ___CSS_LOADER_EXPORT___;
